import CommonStore from './commonStore';
import UserStore from './usersStore';
import SubscriptionsStore from './subscriptionsStore';
import ListStore from './listsStore';
import MainStore from './viewer';
import CompanyStore from './companyStore';
import AutomationStore from './automationStore';
import AssessmentStore from './assessmentStore';
import AssessmentEmployeesStoresFactory from './assessmentEmployeesStore';
import AssessmentEmployeeListsStore from './assessmentEmployeeListsStore';
import AutomationEmployeesStoresFactory from './automationEmployeesStore';
import AutomationEmployeeListsStore from './automationEmployeeListsStore';
import DynamicListCreateStore from './dynamicListCreateStore';
import PartnerStore from './partnerStore';
import AuthStore from './authStore';
import CatalogStore from './catalogStore';
import ResourcesStore from './resourcesStore';
import MailStore from './mailStore';
import BrandingStore from './brandingStore';
import PPVStore from './ppvStore';
import VideosStore from './videosStore';
import QuestionStore from './questions';
import HistoryStore from './historyStore';
import Cmi5Store from './cmi5Store';
import AzureGroupsStore from './azureGroupsStore';
import GoogleGroupsStore from './googleGroupsStore';
import ReportsStore from './reportsStore';
import LanguageStore from './languageStore';
import AwareExposeStore from './awareExposeStore';
import AwarePhishStore from './awarePhishStore';
import VantaGroupsStore from './vantaGroupsStore';
import {ASSESSMENT_TYPES} from '../utils/constants';

const commonStore = new CommonStore();
const historyStore = new HistoryStore();

const store = new MainStore(commonStore);
const userStore = new UserStore(commonStore, historyStore, store);
const subscriptionStore = new SubscriptionsStore(commonStore);
const companyStore = new CompanyStore(store, subscriptionStore, commonStore);
const brandingStore = new BrandingStore(store, companyStore);
const listStore = new ListStore(userStore, commonStore, store);
const catalogStore = new CatalogStore();
const questionStore = new QuestionStore(companyStore, store);
const authStore = new AuthStore(commonStore, store, brandingStore);

const assessmentStore = new AssessmentStore(
    listStore,
    store,
    commonStore,
    companyStore,
    authStore,
    brandingStore,
    {type: ASSESSMENT_TYPES.DEFAULT}
);

const assessmentInsightStore = new AssessmentStore(
    listStore,
    store,
    commonStore,
    companyStore,
    authStore,
    brandingStore,
    {type: ASSESSMENT_TYPES.ASSESSMENT_INSIGHT}
);

const automationStore = new AutomationStore(
    listStore,
    catalogStore,
    store,
    commonStore,
    companyStore,
    authStore,
    historyStore,
    brandingStore
);

const partnerStore = new PartnerStore(authStore);

const languageStore = new LanguageStore();
const stores = {
    authStore,
    store,
    brandingStore,
    commonStore,
    userStore,
    listStore,
    companyStore,
    partnerStore,
    resourcesStore: new ResourcesStore(commonStore),
    subscriptionStore,
    catalogStore,
    mailStore: new MailStore(),
    ppvStore: new PPVStore(),
    automationStore,
    assessmentStore,
    assessmentInsightStore,
    assessmentEmployeesStoresFactory: new AssessmentEmployeesStoresFactory(
        assessmentStore,
        commonStore,
        store
    ),
    assessmentEmployeeListsStore: new AssessmentEmployeeListsStore(
        assessmentStore
    ),
    assessmentInsightParticipantStoresFactory: new AssessmentEmployeesStoresFactory(
        assessmentInsightStore,
        commonStore,
        store
    ),
    automationEmployeesStoresFactory: new AutomationEmployeesStoresFactory(
        automationStore,
        commonStore,
        store
    ),
    azureGroupsStore: new AzureGroupsStore(
        automationStore,
        commonStore,
        companyStore
    ),
    vantaGroupsStore: new VantaGroupsStore(
        automationStore,
        commonStore,
        companyStore
    ),
    googleGroupsStore: new GoogleGroupsStore(
        automationStore,
        commonStore,
        companyStore
    ),
    automationEmployeeListsStore: new AutomationEmployeeListsStore(
        automationStore
    ),
    dynamicListCreateStore: new DynamicListCreateStore(
        listStore
    ),
    videosStore: new VideosStore(),
    questionStore,
    historyStore,
    cmi5Store: new Cmi5Store(),
    reportsStore: new ReportsStore(),
    languageStore,
    awareExposeStore: new AwareExposeStore(),
    awarePhishStore: new AwarePhishStore(),
};

store.setAuthStore(stores.authStore);
store.setPartnerStore(stores.partnerStore);

export default stores;
